import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

type Highlight = {
  key: string
  to: string
  iconBg: string
  icon: React.ReactNode
}

const highlights: Highlight[] = [
  {
    key: 'now',
    to: '/profile',
    iconBg: 'bg-blue-100 text-blue-600',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    key: 'focus',
    to: '/blog',
    iconBg: 'bg-pink-100 text-pink-600',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
  },
  {
    key: 'certs',
    to: '/profile',
    iconBg: 'bg-yellow-100 text-yellow-600',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ),
  },
  {
    key: 'skills',
    to: '/profile',
    iconBg: 'bg-green-100 text-green-600',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
      </svg>
    ),
  },
]

export function Highlights() {
  const { t } = useTranslation('home')

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('highlights.sectionTitle')}</h2>
          <p className="text-gray-600">{t('highlights.sectionDescription')}</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {highlights.map((card) => (
            <Link
              key={card.key}
              to={card.to}
              className="group bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-shadow flex flex-col"
            >
              <div className={`w-10 h-10 rounded-lg ${card.iconBg} flex items-center justify-center mb-4`}>
                {card.icon}
              </div>
              <span className="text-xs font-medium text-gray-500 mb-1">
                {t(`highlights.${card.key}.label`)}
              </span>
              <span className="text-lg font-bold text-gray-900 mb-1">
                {t(`highlights.${card.key}.value`)}
              </span>
              <span className="text-sm text-gray-600">
                {t(`highlights.${card.key}.sub`)}
              </span>
              <span className="mt-4 inline-flex items-center gap-1 text-blue-600 text-sm font-medium group-hover:gap-2 transition-all">
                {t(`highlights.${card.key}.link`)}
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
